import { Helpers } from "@/global-scripts/helpers";

export default class PageTracker {
  private target: HTMLElement;
  private win: JQuery<Window>;
  private startOffset: number;
  private timeStart: number;
  private progress: number;
  private offsetTop: number;
  private targetHeight: number;
  private windowHeight: number;

  private onScroll: () => any;
  private onResize: () => any;

  init(target: HTMLElement, startOffset = 0) {
    this.destroy();

    this.target = target;
    this.win = $(window);
    this.startOffset = startOffset;
    this.timeStart = Date.now();
    this.progress = 0;

    this.calculateSize();
    this.checkProgress();

    this.onScroll = Helpers.throttle(this.checkProgress, 250, this).bind(this);
    this.onResize = Helpers.throttle(this.calculateSize, 250, this).bind(this);

    window.addEventListener("resize", this.onResize);
    window.addEventListener("scroll", this.onScroll);
  }

  checkProgress() {
    const scrollBot = this.win.scrollTop() + this.windowHeight;
    const completed = scrollBot - this.offsetTop;
    const scrollPercent = completed / Math.max(this.targetHeight, 1);
    const current = Math.round((scrollPercent * 100) / 5) * 5;

    if (current > this.progress) {
      this.progress = Math.min(100, current);
    }
  }

  calculateSize() {
    this.offsetTop = this.target.offsetTop + this.startOffset;
    this.targetHeight = $(this.target).outerHeight(true);
    this.windowHeight = this.win.height();
  }

  getProgress() {
    return this.progress;
  }

  getDuration() {
    return Math.round((Date.now() - this.timeStart) / 1000);
  }

  destroy() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("scroll", this.onScroll);
  }
}
